"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getLocaleFormat = getLocaleFormat;
exports.parseDate = parseDate;
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _isValid = _interopRequireDefault(require("date-fns/isValid"));
var _Locales = _interopRequireDefault(require("../../StandaloneDatePicker/internal/Locales"));
/**
 * A parsing function to return a valid date or null if the dateString is invalid
 *
 * Used in: handleInputChange, handleInputBlur within the DatePicker and DateRangePicker
 *
 * @param {string} dateString Date in string
 * @param {string} locale Locale to parse in - This string is used to insert the correct locale we support
 * @param {object} props - props from the component that is being sent in
 */
function parseDate(dateString, locale, formatProp) {
  var referenceDate = new Date(); // this defines the values missing from the parsed dateString (date-fns docs)

  // Accounts for ISO formats and consumer provided format prop
  var parsedDate;
  if (formatProp && (0, _isValid.default)((0, _parse.default)(dateString, formatProp, referenceDate, {
    locale: _Locales.default[locale]
  }))) {
    parsedDate = (0, _parse.default)(dateString, formatProp, referenceDate, {
      locale: _Locales.default[locale]
    });
  } else if ((0, _isValid.default)((0, _parse.default)(dateString, getLocaleFormat(locale), referenceDate, {
    locale: _Locales.default[locale]
  }))) {
    parsedDate = (0, _parse.default)(dateString, getLocaleFormat(locale), referenceDate, {
      locale: _Locales.default[locale]
    });
  } else if ((0, _isValid.default)((0, _parse.default)(dateString, 'yyyy-MM-dd', referenceDate, {
    locale: _Locales.default[locale]
  }))) {
    parsedDate = (0, _parse.default)(dateString, 'yyyy-MM-dd', referenceDate, {
      locale: _Locales.default[locale]
    });
  } else if ((0, _isValid.default)((0, _parse.default)(dateString, 'M/dd/yyyy', referenceDate, {
    locale: _Locales.default[locale]
  }))) {
    parsedDate = (0, _parse.default)(dateString, 'M/dd/yyyy', referenceDate, {
      locale: _Locales.default[locale]
    });
  } else if ((0, _isValid.default)((0, _parse.default)(dateString, 'M/d/yyyy', referenceDate, {
    locale: _Locales.default[locale]
  }))) {
    parsedDate = (0, _parse.default)(dateString, 'M/d/yyyy', referenceDate, {
      locale: _Locales.default[locale]
    });
  }
  return (0, _isValid.default)(parsedDate) ? parsedDate : null;
}

/**
 * A function to return the formatting pattern associated with the locale
 *
 * Used in: handleDayMouseEnter and getFormattedDateString within the DatePicker and DateRangePicker, and the parseDateFunction
 *
 * @param {string} locale This locale string is used to get the corresponding format pattern
 * @returns The formatting pattern for the corresponding locale
 */
function getLocaleFormat(locale) {
  if (locale === 'fr-CA') {
    return 'yyyy-MM-dd';
  } else if (locale) {
    return _Locales.default[locale].formatLong.date({
      width: 'short'
    });
  } else {
    return 'M/dd/yyyy';
  }
}